import { FC, PropsWithChildren, RefObject } from "react";
import classNames from "classnames";
import FadeInAnimation from "components/base/fade-in/FadeInAnimation";
import styles from "./navigation-bar.module.sass";
type Props = {
    ref?: RefObject<HTMLDivElement | null>;
    dataTestId?: string;
    className?: string;
};
export const NavigationBar: FC<PropsWithChildren<Props>> = ({
    children,
    ref,
    dataTestId,
    className,
}) => {
    return (
        <FadeInAnimation>
            <div
                className={classNames(styles.container, className)}
                ref={ref}
                data-testid={dataTestId}>
                {children}
            </div>
        </FadeInAnimation>
    );
};
